import { doc, setDoc, increment } from "firebase/firestore";
import { db } from "../firebase";

function detectDevice() {
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

function detectSource() {
  const ref = document.referrer;
  if (!ref) return "direct";
  if (/google|bing|yahoo|duckduckgo/i.test(ref)) return "organic";
  if (/facebook|instagram|tiktok|twitter|x\.com/i.test(ref)) return "social";
  return "referral";
}

export async function trackVisit() {
  // Only count once per session
  if (sessionStorage.getItem("visit_tracked")) return;
  sessionStorage.setItem("visit_tracked", "1");

  try {
    const today = new Date().toISOString().split("T")[0]; // e.g. "2026-06-25"
    const ref = doc(db, "analytics", "visits");
    const device = detectDevice();
    const source = detectSource();

    await setDoc(
      ref,
      {
        total: increment(1),
        [today]: increment(1),
        [`devices.${device}`]: increment(1),
        [`sources.${source}`]: increment(1),
      },
      { merge: true },
    );
  } catch (err) {
    console.error("Visit tracking error:", err);
  }
}